import React from 'react'

import { reverse } from 'named-urls'
import moment from 'moment'

import { Typography, makeStyles, Box } from '@material-ui/core'

import helpers from 'helpers'

import { DotStatus, Link } from 'components'
import { routes } from 'routes'
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
} from 'components/Table'
import usePermissions from 'hooks/usePermissions'

import styles from './styles'

const useStyles = makeStyles(styles)

const TableRowInvoice = ({ invoice, ...rest }) => {
  const classes = useStyles()

  return (
    <TableRow {...rest}>
      <TableCell align="left">
        <Box display="flex" alignItems="center">
          <Box mr={1 / 2}>
            <Typography component="span" variant="body2">
              {invoice.contract ? 'Assinatura:' : 'Fatura:'}
            </Typography>
          </Box>
          {invoice.contract && invoice.contract.id ? (
            <Link
              to={reverse(routes.contracts.show, {
                contractId: invoice.contract.id,
              })}
              noPropagate
            >
              {invoice.contract && invoice.contract.id}
            </Link>
          ) : (
            <Typography>Avulsa</Typography>
          )}
        </Box>
        <div>
          <Typography component="span" variant="body2">
            Fatura:
          </Typography>{' '}
          {invoice.identifier}
        </div>
      </TableCell>
      <TableCell className={classes.tableCellCustomer}>
        <Typography noWrap>
          <Typography component="span" variant="body2">
            Nome:
          </Typography>{' '}
          {invoice.customer.name}
        </Typography>
        <Typography noWrap>
          <Typography component="span" variant="body2">
            Email:
          </Typography>{' '}
          {invoice.customer.email}
        </Typography>
        <Typography noWrap>
          <Typography component="span" variant="body2">
            Documento:
          </Typography>{' '}
          {helpers.people.formatMainDocument(invoice.customer)}
        </Typography>
      </TableCell>
      <TableCell>
        {invoice.serviceTaxInvoice ? (
          <>
            <Typography variant="body2">
              {helpers.taxInvoices.status(invoice.serviceTaxInvoice.status)}
            </Typography>
            {invoice.serviceTaxInvoice.status !== 'pending_issued' &&
              invoice.serviceTaxInvoice.status !== 'error' && (
                <>
                  <div>
                    <Typography component="span" variant="body2">
                      ID:
                    </Typography>{' '}
                    {invoice.serviceTaxInvoice.nfId}
                  </div>
                  {invoice.serviceTaxInvoice.canceledAt ? (
                    <div>
                      <Typography component="span" variant="body2">
                        Data cancelamento:
                      </Typography>{' '}
                      {moment(invoice.serviceTaxInvoice.canceledAt).format(
                        'DD/MM/YYYY',
                      )}
                    </div>
                  ) : (
                    <div>
                      <Typography component="span" variant="body2">
                        Data emissão:
                      </Typography>{' '}
                      {moment(invoice.serviceTaxInvoice.issuedAt).format(
                        'DD/MM/YYYY',
                      )}
                    </div>
                  )}
                </>
              )}
          </>
        ) : (
          <Typography variant="body2">Não gerada</Typography>
        )}
      </TableCell>
      <TableCell align="left">
        <div>
          <Typography component="span" variant="body2">
            Emissão:
          </Typography>{' '}
          {moment(invoice.createdAt).format('DD/MM/YYYY')}
        </div>
        <div>
          <Typography component="span" variant="body2">
            Vencimento:
          </Typography>{' '}
          {moment(invoice.dueDate).format('DD/MM/YYYY')}
        </div>
        {invoice.paidAt ? (
          <div>
            <Typography component="span" variant="body2">
              Data de Pagamento:
            </Typography>{' '}
            {moment(invoice.paidAt).format('DD/MM/YYYY')}
          </div>
        ) : (
          <div></div>
        )}
      </TableCell>
      <TableCell align="right">{helpers.currency(invoice.amountDue)}</TableCell>
      <TableCell align="center">
        <DotStatus
          statusName={helpers.invoices.status(invoice.status)}
          statusTag={invoice.status}
          entity="invoice"
        />
      </TableCell>
    </TableRow>
  )
}

const InvoicesTable = ({ invoices, isLoading }) => {
  const permissions = usePermissions()
  const permittedShowInvoice = permissions.permitted('show_invoice')
  return (
    <Table
      size="medium"
      emptyMessage="Nenhuma fatura encontrada"
      isLoading={isLoading}
      noWrap
    >
      <TableHead>
        <TableRow>
          <TableCell align="left" bodySkeletonHeight={40}>
            Identificador
          </TableCell>
          <TableCell bodySkeletonHeight={60}>Cliente</TableCell>
          <TableCell bodySkeletonHeight={40}>Nota fiscal</TableCell>
          <TableCell align="left" bodySkeletonHeight={40}>
            Datas da Fatura
          </TableCell>
          <TableCell align="right">Valor total</TableCell>
          <TableCell align="center">Status</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {invoices &&
          invoices.map(invoice => (
            <TableRowInvoice
              invoice={invoice}
              key={invoice.id}
              pointer={permittedShowInvoice}
              to={
                permittedShowInvoice &&
                reverse(routes.invoices.show, { invoiceId: invoice.id })
              }
              hover
            />
          ))}
      </TableBody>
    </Table>
  )
}

export default InvoicesTable
